import Link from "./Link";
import PrimaryLink from "./PrimaryLink";
import ButtonLink from "./ButtonLink";
import SmallLink from "./SmallLink";
import MailToLink from "./MailToLink";

export default Link;
export { PrimaryLink, ButtonLink, SmallLink, MailToLink };
